var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUiArrowNext(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 20,
    width: 25,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M20.43 9.1l-4.694-4.827L16.973 3l6.806 7-6.806 7-1.237-1.273L20.43 10.9H1.28V9.1z",
    fillRule: "evenodd"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-ui--arrow-next-490231ccf0a245a5efa8cb2fa5525bed.svg";
export { SvgIconUiArrowNext as Component };